import { fetchStrapi } from './strapi';

export interface LegalSection {
  title: string;
  content: string;
}

export interface Agb {
  title: string;
  sections: LegalSection[];
}

export async function fetchAgb(): Promise<Agb | null> {
  try {
    const response = await fetchStrapi<any>('/agb?populate=*');

    if (!response.data) {
      return null;
    }

    const data = response.data;

    return {
      title: data.titel || '',
      sections: (data.abschnitte || []).map((s: any) => ({
        title: s.titel || '',
        content: s.inhalt || '',
      })),
    };
  } catch (error) {
    console.error('Error fetching AGB from Strapi:', error);
    return null;
  }
}
